module.exports = __webpack_public_path__ + "ui-static/img/hooks-no-items_light.f480b193.svg";